import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlAccount = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M32 31.76C38.8428 31.76 44.39 26.2128 44.39 19.37C44.39 12.5272 38.8428 6.97998 32 6.97998C25.1572 6.97998 19.61 12.5272 19.61 19.37C19.61 26.2128 25.1572 31.76 32 31.76Z",
			stroke: "#311123",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.54004 56.22C7.54004 42.71 18.49 31.76 32 31.76C45.51 31.76 56.46 42.71 56.46 56.22",
			stroke: "#311123",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32 29.48C37.5836 29.48 42.11 24.9536 42.11 19.37C42.11 13.7864 37.5836 9.26001 32 9.26001C26.4164 9.26001 21.89 13.7864 21.89 19.37C21.89 24.9536 26.4164 29.48 32 29.48Z",
			fill: "#D0F5DA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.78003 56.11C9.78003 43.84 19.73 33.89 32 33.89C44.27 33.89 54.22 43.84 54.22 56.11",
			fill: "#D0F5DA"
		})
	]
});
export default SvgSlAccount;
